import * as AppConstants from "../../constants/AppConstants";
import { styled } from "baseui";
import { Block } from "baseui/block";
import { Grid, Cell } from 'baseui/layout-grid';

const MainContainer = styled(Block, ({ $theme }) => ({
  // margin: "auto auto",
  marginTop: "100px",
}));
const MainGridContainer = styled(Grid, ({ $theme }) => ({
  margin: "auto auto",
  padding: AppConstants.APP_MAIN_PADDING,

}));

const MainArea = styled(Cell, ({ $theme }) => ({
  display: "flex",
  width: "100%",
  padding: "5px 70px 30px 30px",
  // overflowY: "scroll",
  height: AppConstants.APP_GLOBAL_HEIGHT,
}));

const SidebarArea = styled(Cell, ({ $theme }) => ({
  borderRight: "2px solid",
}));

export { MainContainer, MainGridContainer, MainArea, SidebarArea };
